import React from "react";

const DefaultErrorBoundary = ({ children }) => children;

export default DefaultErrorBoundary;
